import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';


@Component({
  selector: 'app-rimanda-in-istruttoria-modal',
  templateUrl: './rimanda-in-istruttoria-modal.component.html',
  styleUrls: ['./rimanda-in-istruttoria-modal.component.scss']
})
export class RimandaInIstruttoriaModalComponent implements OnInit {

  // SALVA
  public buttonLabel: string = 'APPLICATION.BACK_OFFICE.RICERCA_PRATICA.MODAL.BUTTONS.SALVA';
  public form: FormGroup = this.formBuilder.group({
    note_pa: [null, [Validators.required, Validators.maxLength(2000)]]
  });

  public erroreCampoVuoto = false;

  ngOnInit() {
    if (this.data.buttonLabel) this.buttonLabel = this.data.buttonLabel;
  }

  constructor(
    public dialogRef: MatDialogRef<RimandaInIstruttoriaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, buttonLabel?: string, text?: string, config: 'plain' | 'extended' },
    private formBuilder: FormBuilder
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  getOutPutData() {
    if (this.form.valid)
      this.dialogRef.close(this.form.value);
    else
      this.form.get('note_pa').setErrors({custom: 'APPLICATION.FRONT_OFFICE.ERRORI.RICHIESTO'});
    this.form.get('note_pa').updateValueAndValidity();
  }

}
